import { render, staticRenderFns } from "./CsSegmendtedControltem.vue?vue&type=template&id=488b1f44&"
import script from "./CsSegmendtedControltem.vue?vue&type=script&setup=true&lang=js&"
export * from "./CsSegmendtedControltem.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports